module.exports = __webpack_public_path__ + "static/pic02-82696bae400167cab1f40785af50a9ce.jpg";